  <!-- <pagesnavbar-cmp></pagesnavbar-cmp> -->
  <router-outlet></router-outlet>
  <!-- <fixedplugin-cmp></fixedplugin-cmp> -->
